import { useEffect, useState } from 'react';
import { Actions } from '@src/types/Actions';

export function useSOCConfig(actions: Actions, siteId: string) {
  const [socRange, setSOCRange] = useState({ min: 10, max: 90 });

  useEffect(() => {
    const abortController = new AbortController();

    const fetchSOCConfig = async () => {
      try {
        // Pass the abort signal to the API call
        const result = await actions.getSystemConfig(siteId, ['Fault Config']);

        // Check if aborted before setting state
        if (abortController.signal.aborted) {
          return;
        }

        if (!Array.isArray(result) || !result.length) {
          return;
        }

        const faults = result
          .flatMap((el) =>
            Array.isArray(el.body?.Faults) ? el.body.Faults : [],
          )
          .filter((fault) =>
            fault?.['Fault Name']?.includes('Battery Rack SOC'),
          );

        const lowFault = faults.find(
          (f) => f['Fault Name'] === 'Battery Rack SOC Low',
        );
        const highFault = faults.find(
          (f) => f['Fault Name'] === 'Battery Rack SOC High',
        );

        // Only set state if not aborted
        if (!abortController.signal.aborted) {
          setSOCRange({
            min: lowFault?.['Low Threshold'] ? +lowFault['Low Threshold'] : 10,
            max: highFault?.['Hi Threshold'] ? +highFault['Hi Threshold'] : 90,
          });
        }
      } catch (error) {
        if (!abortController.signal.aborted) {
          console.error('Failed to fetch SOC config:', error);
        }
      }
    };

    fetchSOCConfig();
    return () => abortController.abort();
  }, [actions.getSystemConfig, siteId]);

  return socRange;
}
